// Replies that mean the login itself is unusable. The backend answers an expired admin token with 403,
// so 403 alone cannot mean "log out": permission and business refusals (OWN_REQUEST, …) stay on the page.
const SESSION_CODES = new Set(['STAFF_NOT_FOUND', 'ACCOUNT_SUSPENDED', 'ACCOUNT_INACTIVE', 'ACCOUNT_PENDING_APPROVAL', 'TOKEN_INVALID', 'TOKEN_EXPIRED', 'TOKEN_REVOKED']);
const SESSION_MESSAGES = new Set([
    'Invalid or expired token',
    'Staff account not found',
    'Account is inactive or suspended',
    'Admin dashboard access required',
    'Admin access required',
]);

export const endsSession = (status: number | undefined, data: unknown): boolean => {
    if (status === 401) return true;
    if (status !== 403) return false;
    const body = (data && typeof data === 'object' ? data : {}) as { code?: unknown; message?: unknown };
    // A bare 403 with nothing to read is treated as before (log out), the safe side.
    if (body.code === undefined && body.message === undefined) return true;
    // The server could not check the token (e.g. a key-fetch outage): not a reason to sign out.
    if (body.code === 'TOKEN_CHECK_FAILED') return false;
    return (typeof body.code === 'string' && SESSION_CODES.has(body.code))
        || (typeof body.message === 'string' && SESSION_MESSAGES.has(body.message));
};
